import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHero } from "@/components/PageHero";
import { api, formatApiErrorDetail } from "@/lib/api";
import { IMG } from "@/lib/assets";

const PROGRAMS = ["Community Opportunity Micro-Grant", "Rising Leaders Youth Mentorship", "Financial Wellness Workshop Series", "Emergency Family Assistance"];

export default function Apply() {
  const [form, setForm] = useState({ program: PROGRAMS[0], name: "", email: "", phone: "", goal: "", details: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post("/applications", form);
      toast.success(data.message);
      setForm({ program: PROGRAMS[0], name: "", email: "", phone: "", goal: "", details: "" });
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <main>
      <PageHero overline="Program Applications" image={IMG.youth2}
        title="Apply to a Foundation-operated program"
        subtitle="Tell us about your goals. Our program team reviews every application and will follow up with next steps." />
      <section className="max-w-2xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-20">
        <form onSubmit={submit} className="bg-white rounded-3xl border border-slate-200 p-8 shadow-xl space-y-5">
          <div><Label>Program *</Label>
            <Select value={form.program} onValueChange={(v) => set("program", v)}>
              <SelectTrigger className="mt-2 h-12 rounded-xl" data-testid="apply-program"><SelectValue /></SelectTrigger>
              <SelectContent>{PROGRAMS.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="grid sm:grid-cols-2 gap-5">
            <div><Label>Full Name *</Label><Input required value={form.name} onChange={(e) => set("name", e.target.value)} className="mt-2 h-12 rounded-xl" data-testid="apply-name" /></div>
            <div><Label>Email *</Label><Input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="mt-2 h-12 rounded-xl" data-testid="apply-email" /></div>
          </div>
          <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => set("phone", e.target.value)} className="mt-2 h-12 rounded-xl" data-testid="apply-phone" /></div>
          <div><Label>Your goal *</Label><Input required value={form.goal} onChange={(e) => set("goal", e.target.value)} placeholder="What are you hoping to achieve?" className="mt-2 h-12 rounded-xl" data-testid="apply-goal" /></div>
          <div><Label>Additional details</Label><Textarea value={form.details} onChange={(e) => set("details", e.target.value)} className="mt-2 rounded-xl" data-testid="apply-details" /></div>
          <Button type="submit" disabled={loading} data-testid="apply-submit" className="w-full h-14 rounded-full bg-navy-900 hover:bg-navy-700 text-white font-bold">
            {loading ? <><Loader2 className="h-5 w-5 mr-2 animate-spin" /> Submitting...</> : <><FileText className="h-5 w-5 mr-2" /> Submit Application</>}
          </Button>
        </form>
      </section>
    </main>
  );
}
